var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39185 22.5H22.3918",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3418 22.5L3.3918 10.47C3.3918 9.85999 3.6818 9.28004 4.1618 8.90004L11.1618 3.45003C11.8818 2.89003 12.8918 2.89003 13.6218 3.45003L20.6218 8.89003C21.1118 9.27003 21.3918 9.84999 21.3918 10.47V22.5",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3918 17.5H11.3918C10.5618 17.5 9.89185 18.17 9.89185 19V22.5H14.8918V19C14.8918 18.17 14.2218 17.5 13.3918 17.5Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89185 14.25H7.89185C7.34185 14.25 6.89185 13.8 6.89185 13.25V11.75C6.89185 11.2 7.34185 10.75 7.89185 10.75H9.89185C10.4418 10.75 10.8918 11.2 10.8918 11.75V13.25C10.8918 13.8 10.4418 14.25 9.89185 14.25Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8918 14.25H14.8918C14.3418 14.25 13.8918 13.8 13.8918 13.25V11.75C13.8918 11.2 14.3418 10.75 14.8918 10.75H16.8918C17.4418 10.75 17.8918 11.2 17.8918 11.75V13.25C17.8918 13.8 17.4418 14.25 16.8918 14.25Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3918 7.5L19.3618 4.5H14.9618",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse1);
export default __webpack_public_path__ + "static/media/house1.4b53a1492e61cfcf78aa275d01b4b9f8.svg";
export { ForwardRef as ReactComponent };